import { useDispatch } from '@redux';
import {
  getByIdOrdersReturn,
  failedQCReturn,
} from '@redux/ordersReturn/actions';
import { Form, Input, Modal, Select } from 'antd';
import FormUpload from 'components/form/FormUpload';
import { FAILED_QC_REASON } from 'constants/ordersReturn';
import useToggleModal from 'hooks/useToogleModal';
import { get } from 'lodash';
import React, { useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

const formatHightLight = (src, values) => {
  if (values.thumbnail === src)
    return {
      color: 'var(--primary)',
      label: 'Main',
      className: 'ant-tag-primary',
    };
  if (values.secondaryThumbnail === src)
    return {
      color: 'var(--color-purple)',
      label: 'Secondary',
      className: 'ant-tag-secondary',
    };
  return null;
};

const FailedQCModal = ({ id }, ref) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { visible, toggleModal } = useToggleModal();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      toggleModal();
    },
  }));

  const handleValidation = async (values) => {
    setLoading(true);
    dispatch(failedQCReturn({ data: { id: id, data: values } }))
      .then(() => {
        dispatch(
          getByIdOrdersReturn({
            data: { id: id },
            options: { isRequestApi: true, isRefresh: true },
          }),
        ).finally(() => {
          setLoading(false);
          if (visible) toggleModal();
        });
      })
  };

  return (
    <Modal
      open={visible}
      title={t('ordersReturn.modal.failQC')}
      onCancel={() => visible && toggleModal()}
      onOk={() => form.submit()}
      width={462}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" onFinish={handleValidation}>
        <Form.Item
          name="failedQCReason"
          label={t('ordersReturn.reason')}
          rules={[{ required: true }]}
        >
          <Select placeholder="Select..." allowClear>
            {Object.values(FAILED_QC_REASON)?.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {t(item?.label)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={t('ordersReturn.note')}
          name="failedQCNote"
          rules={[{ required: true }]}
        >
          <Input.TextArea placeholder="Select..." />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(o, n) => {
            return get(o, 'failedQCImages') !== get(n, 'failedQCImages');
          }}
        >
          {({ getFieldValue }) => {
            const value = getFieldValue('failedQCImages');
            return (
              <FormUpload
                formatHightLight={formatHightLight}
                name="failedQCImages"
                label={t('ordersReturn.image')}
                highlightName="avatar"
                accept="image/*"
                form={form}
                value={value}
                type="array"
              />
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.forwardRef(FailedQCModal);
